import { useSyncExternalStore } from 'react';

let current = Date.now();
const listeners = new Set<() => void>();
let interval: ReturnType<typeof setInterval> | undefined;
function refresh() {
  current = Date.now();
  for (const listener of listeners) listener();
}
function onVisibility() {
  if (document.visibilityState === 'visible') refresh();
}
function subscribe(listener: () => void) {
  listeners.add(listener);
  if (listeners.size === 1) {
    current = Date.now();
    interval = setInterval(() => {
      if (document.visibilityState !== 'hidden') refresh();
    }, 1000);
    document.addEventListener('visibilitychange', onVisibility);
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      clearInterval(interval);
      interval = undefined;
      document.removeEventListener('visibilitychange', onVisibility);
    }
  };
}
const noopSubscribe = () => () => {};
/** One shared clock for all elapsed values. Controlled now also supports deterministic SSR/previews. */
export function useResponseClock(now?: number, resolutionMs = 1000) {
  return useSyncExternalStore(
    now === undefined ? subscribe : noopSubscribe,
    () => now ?? Math.floor(current / resolutionMs) * resolutionMs,
    () => now ?? 0,
  );
}
